<template>
<div class="chapter">
<div class="inner_page">
<p class="h1" id="pz7-1">
<a href="#/Contents#a1" id="b1">Why Rule of Thumb? </a></p>
<p class="tx" id="pz7-2">
					This book is part of the Rule of Thumb series produced in affiliation with the Rule
					of Thumb for Business whose mission is to “enrich business growth and development.”
					The Rule of Thumb series offers basic information in plain language that will help
					you start, grow and sustain your business. The explanation for using the <i>“rule of
					thumb”</i> concept was introduced in the first book and is included again here. </p>
<p class="tx" id="pz7-3">
					Throughout history, a <i>“rule of thumb”</i> was used in measurements in a wide variety
					of businesses and vocations. The following list gives a few examples of how the thumb
					was used for measuring: </p>
<p class="pub" id="pz7-4">
<span style="margin-right: 0.8em;">•</span> In agriculture, the thumb was used to measure the depth at which to plant a seed.
					</p>
<p class="pub" id="pz7-5">
<span style="margin-right: 0.8em;">•</span> In restaurants and pubs, the thumb was used to measure the temperature of beer
					and ale. </p>
<p class="pub" id="pz7-6">
<span style="margin-right: 0.8em;">•</span> Tailors used the thumb to make sure enough space was allowed between the person’s
					skin and his/her clothing. For example, the space between the cuff of the sleeve
					and the wrist had to be at least the width of the thumb. </p>
<p class="pub" id="pz8-1">
<span style="margin-right: 0.8em;">•</span> Carpenters used the width of the thumb rather than a ruler for measuring. For example,
					a notch in a board may need to be cut two thumb widths from the edge. </p>
<p class="tx" id="pz8-2" style="margin-top:1.2em;">
					A <i>“rule of thumb”</i> is an idea or rule that may be applied in most situations, but
					not all. The <i>“rules of thumb”</i> in this book give you many reliable, convenient and
					simple rules that will help you remember many “dos” and “don’ts” that go with owning
					and running a business. Many of these concepts can also be used in a variety of business
					situations ranging from management, sales, customer service, human resources and
					leadership. The information is designed to be easy, simple and action-oriented. To
					learn more about the Rule of Thumb for Business organization visit our website at
					<a href="http://www.ruleofthumbbiz.com" id="AUS" target="_blank">www.ruleofthumbbiz.com</a>. – <i>Rule of Thumb for Business.</i> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Why_Rule_of_Thumb.vue?219d7c21